export class AfterTimeoutExecutor {

    private timerid = null as null|number|unknown;
    private readonly timeout;
    private readonly callback: () => void;

    public constructor(timeout, callback: () => void) {
        this.timeout = timeout;
        this.callback = callback;
    }

    public executeAfterTimeout() {
        if (this.timerid !== null) {
            clearTimeout(this.timerid as number);
        }

        this.timerid = setTimeout(() => {

            this.callback();
            this.timerid = null;
        }, this.timeout);
    }
}